import React from 'react';
import Component from 'src/helpers/Component/Component';
import { GetStaticComponentProps, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  MediaPrimaryStaticProps,
  MediaSecondaryStaticProps,
  getMediaPrimaryStaticProps,
  getMediaSecondaryStaticProps,
} from 'src/helpers/Media';
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import ContentBlockWithMediaAW from './ContentBlockWithMediaAW';
import ContentBlockWithMediaRba from './ContentBlockWithMediaRba';
import { useTheme } from 'lib/context/ThemeContext';
export type ContentBlockWithMediaProps =
  Feature.EnterpriseWeb.Enterprise.Components.General.ContentBlockWithMedia.ContentBlockWithMedia;

const ContentBlockWithMedia = (props: ContentBlockWithMediaProps): JSX.Element => {
  const { themeName } = useTheme();
  return (
    <Component variant="lg" dataComponent="general/contentblockwithmedia" {...props}>
      {themeName === 'aw' ? (
        <ContentBlockWithMediaAW {...props} />
      ) : (
        <ContentBlockWithMediaRba {...props} />
      )}
    </Component>
  );
};

export const getStaticProps: GetStaticComponentProps = async (rendering) => {
  const datasource = rendering as ContentBlockWithMediaProps;
  const mediaStaticProps: MediaPrimaryStaticProps & MediaSecondaryStaticProps = {};

  if (!datasource) {
    return mediaStaticProps;
  }

  mediaStaticProps.mediaPrimary = await getMediaPrimaryStaticProps(datasource);
  mediaStaticProps.mediaSecondary = await getMediaSecondaryStaticProps(datasource);

  return mediaStaticProps;
};

export default withDatasourceCheck()<ContentBlockWithMediaProps>(ContentBlockWithMedia);
